// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uDEP","title":"styles_title__3o5am"};